/* ---------- 이미지 여정 — 좌측 챕터(R0→C1→C2→C3→R9흑백) + 히어로 상태 정물(유일한 컬러) ----------
   Shopify 임베드: quiz-img-web/ 13장을 Files에 업로드 후 IMG_BASE만 CDN 경로로 교체(파일명 유지) */
/* IMG_BASE/IMG_EXT: 템플릿 인라인 부트스트랩에서 선언(liquid file_url) */
const MEDIA_IMGS={r0:"state-r0",c1:"state-c1",c2:"state-c2",c3:"state-c3",r9:"state-r9-bw"};
const STATE_IMGS={P1F:"state-r1",P1T:"state-r2",P2F:"state-r3",P2T:"state-r4",P3F:"state-r5",P3T:"state-r6",P4F:"state-r7",P4T:"state-r8"};
/* 결과 URL 슬러그 8종 (07-17 나은 확정) */
const STATE_SLUGS={P1F:"quiet-drought",P1T:"cracked-drought",P2F:"disguised-dryness",P2T:"prickly-dryness",P3F:"diligent-sebum",P3T:"overtime-sebum",P4F:"steady-rhythm",P4T:"missed-beat"};
const SLUG_KEYS={}; Object.keys(STATE_SLUGS).forEach(k=>{ SLUG_KEYS[STATE_SLUGS[k]]=k; });
function imgUrl(n){ return IMG_BASE+n+IMG_EXT+"?width=800"; }
let __mediaCur="state-r0", __mediaFlip=false;
function setMedia(key){
  const name=MEDIA_IMGS[key]||key; if(!name||name===__mediaCur) return;
  const a=document.getElementById("mediaA"), b=document.getElementById("mediaB");
  if(!a||!b) return;
  const tgt=__mediaFlip?a:b, cur=__mediaFlip?b:a;
  const apply=()=>{ tgt.src=imgUrl(name); tgt.classList.add("on"); cur.classList.remove("on"); __mediaCur=name; __mediaFlip=!__mediaFlip; };
  if(typeof Image==="undefined"){ apply(); return; }
  const im=new Image(); im.onload=apply; im.src=imgUrl(name); /* 미확보 이미지 = 직전 이미지 유지 */
}
function chapterFor(qi){ return qi<=2?"c1":(qi<=5?"c2":"c3"); }

/* ---------- 오늘부터의 리추얼 렌더 (3슬롯 + 검증 제품 + 클릭 로깅) ---------- */
function renderSlots(r, st){
  const box=document.getElementById("slots"), lead=document.getElementById("slotLead"),
        empty=document.getElementById("slotEmpty"), note=document.getElementById("prodNote");
  box.innerHTML="";
  const slots=SLOTS[r.P][r.care];
  let hasProd=false;
  slots.forEach((sl,si)=>{
    const el=document.createElement("div"); el.className="slot";
    if(sl.r) el.setAttribute("data-role", sl.r);  /* 케어 섹션 정렬용 역할(닦기·바르기·막기·차단) — 문구 추측 대신 데이터로 */
    el.innerHTML='<div class="slot-row"><span class="slot-num">'+(si+1)+')</span><div class="slot-main"><p class="slot-how">'+sl.how+'</p><p class="slot-why">'+sl.why+'</p></div></div>';
    if(sl.own){ const ow=document.createElement("p"); ow.className="slot-own"; ow.textContent=sl.own; el.appendChild(ow); }
    (sl.prods||[]).forEach(it=>{
      hasProd=true;
      const id=(typeof it==="string")?it:it.id, p=PRODUCTS[id];
      const why=p.why+((typeof it==="object"&&it.cmt)?" "+it.cmt:"");
      const d=document.createElement("div"); d.className="prod";
      d.innerHTML='<div class="prod-thumb">'+(p.img?'<img src="'+p.img+'" alt="" onerror="this.remove()">':'')+'</div><div class="prod-main"><div class="prod-top"><a class="prod-name" href="'+(p.url||"#")+'" target="_blank" rel="noopener">'+p.n+'<span class="prod-ext">↗</span></a></div><p class="prod-why">'+why+'</p></div>';
      d.querySelector(".prod-name").addEventListener("click",()=>logEvent("quiz_product_click",{state:st.name, product:p.n, slot:sl.t, load:r.load}));
      el.appendChild(d);
    });
    if(sl.alt){ const a=document.createElement("p"); a.className="slot-alt"; a.textContent=sl.alt; el.appendChild(a); }
    box.appendChild(el);
  });
  lead.textContent = SLOT_LEAD_BASE;
  const disc=document.getElementById("slotDisclose");
  if(hasProd){ disc.textContent=SLOT_DISCLOSE; disc.style.display=""; } else disc.style.display="none";
  if(r.P==="P4" && !r.care){ empty.textContent=SLOT_EMPTY_P4F; empty.style.display="block"; }
  else empty.style.display="none";
  note.style.display = "none"; /* 전성분 기준 문구는 고지(*) 둘째 줄로 통합 (07-15 나은) */
}

function finish(opts){
  opts=opts||{};
  document.getElementById("fill").style.width="100%";
  const r=classify();
  const st=STATES[r.P][r.care];
  const oilTxt=["낮음","보통","높음"][st.oil], waterTxt=["낮음","충분"][st.water], barTxt=r.care?"돌봄 필요":"안정";

  /* (1) 심장 문장 = 헤드라인 (결과값은 아래 정도 게이지가 담당) */
  const comp=composeReading(r);
  { var __rl=document.getElementById("rLabel"); if(__rl) __rl.textContent=__L("오늘 내 피부 상태는"); }
  document.getElementById("typeName").textContent = st.name;
  document.getElementById("resultTitle").textContent = comp.heart;
  const __sk=r.P+(r.care?"T":"F");
  if(STATE_IMGS[__sk]) document.getElementById("stateImg").src=imgUrl(STATE_IMGS[__sk]);
  if(typeof Image!=="undefined" && STATE_IMGS[__sk]){ const ci=new Image(); ci.crossOrigin="anonymous"; ci.src=imgUrl(STATE_IMGS[__sk]); window.__cardImg=ci; }
  setMedia(STATE_IMGS[__sk]||"r9");

  document.getElementById("gauges").innerHTML =
    gauge("유분",["낮음","보통","높음"],st.oil)
    + gauge("수분",["낮음","충분"],st.water)
    + gauge("장벽",["안정","돌봄 필요"],r.care?1:0);

  /* (1b) 리딩 — 심장 문장은 상단으로 승격, 하단 중복 노출 없음 */
  const rd=document.getElementById("reading"); rd.innerHTML="";
  comp.paras.forEach(t=>{ const p=document.createElement("p"); p.innerHTML=mdBold(t); rd.appendChild(p); });
  window.__shareHeart=comp.heart;
  window.__shareLabel=__L("유분 ")+__L(oilTxt)+__L(" · 수분 ")+__L(waterTxt)+__L(" · 장벽 ")+__L(barTxt);
  window.__cardData={heart:comp.heart, stateName:st.name, axes:[
    {en:__L("유분"),n:3,on:st.oil,txt:__L(oilTxt)},{en:__L("수분"),n:2,on:st.water,txt:__L(waterTxt)},{en:__L("장벽"),n:2,on:r.care?1:0,txt:__L(barTxt)}]};

  /* (2) 덜어낼 리추얼 — 답변 연동 컷만 (플래그 즉시 노출·심각도순·최대 5) */
  const cuts = flagCuts();
  const cutEmpty=document.getElementById("cutEmpty");
  document.getElementById("dontList").innerHTML="";
  if(cuts.length){ fillList("dontList", cuts, CUT_INFO); cutEmpty.style.display="none"; }
  else { cutEmpty.textContent=CUT_EMPTY; cutEmpty.style.display="block"; }
  const cl=document.getElementById("cutLead"); if(cl) cl.style.display = cuts.length>=2 ? "" : "none";

  /* (3) 오늘부터의 리추얼 — 잘 닦기·잘 채우기·잘 막기 (+검증 제품) */
  renderSlots(r, st);

  /* (3b) 잘 가고 있다는 신호 (실효성 260717) */
  const sg=SIGNAL[__sk], sb=document.getElementById("sigSec");
  if(sb){ if(sg){ document.getElementById("sigText").textContent=sg; sb.style.display=""; } else { sb.style.display="none"; } }

  /* (5) 고민 브릿지 + 노트 */
  const br=document.getElementById("concernBridge");
  if(acc.concern && FRAG.s4[acc.concern]){ br.textContent=FRAG.s4[acc.concern]; br.style.display="block"; }
  else br.style.display="none";
  renderArts(st, acc.concern);

  const label = st.name+" · 유분"+oilTxt+"/수분"+waterTxt+"/장벽"+barTxt;
  document.getElementById("dvState").textContent=st.name+" ("+r.P+(r.care?"·care":"")+")";
  document.getElementById("dvLoad").textContent=r.load+" ("+r.loadScore+")";
  document.getElementById("dvScore").textContent="oil"+acc.oil+" dry"+acc.dry+" bar"+acc.bar;
  window.__wl={state:st.name,load:r.load,slug:STATE_SLUGS[__sk]||""};
  if(!opts.restore){
    logEvent("quiz_complete",{state:st.name, profile:r.P, barrier:barTxt, load:r.load, concern:acc.concern||"none", readout:label});
    try{ if(typeof localStorage!=="undefined") localStorage.setItem("nshQuizR", JSON.stringify({k:__sk, a:answers.slice(0,Q.length)})); }catch(e){}
    try{ if(typeof history!=="undefined" && history.pushState){ const u=new URL(location.href); u.searchParams.set("state",STATE_SLUGS[__sk]||""); u.searchParams.delete("joined"); u.searchParams.delete("ref"); history.pushState({nsh:1},"",u.toString()); } }catch(e){}
  }

  window.__ans=answers.slice(0,Q.length).join("");
  const __rEl=document.getElementById("result");
  const __jd = !!opts.joined || __hasJoined();
  if(opts.restore){ if(__rEl) __rEl.classList.toggle("gated", !opts.shared && !__jd); show("result"); window.scrollTo(0,0); if(opts.shared) decorateShared(); else if(__jd) markJoined(); }
  else{ if(__rEl) __rEl.classList.toggle("gated", !__jd); if(__jd) markJoined(); revealResult(); }  /* 이미 구독한 사람이 퀴즈를 다시 풀면 구독 박스 숨김(2026-08-03) */
}


/* ===== 노트 추천 v2 (2026-08-02) — custom.topics 기반 =====
   고정 태그 풀(LIB) 매핑을 버리고, 각 글의 주제 메타필드와 점수 매칭으로 고른다.
   NSH_ARTICLES/NSH_BLOG_URL 은 page.nsh-quiz.liquid 가 로케일에 맞춰 심는다(제목·URL 자동, 새 글 자동 반영).
   데이터가 없으면 구 LIB 로직으로 폴백. */
var CONCERN_TOPICS={
  B:{main:["wrinkles","firmness"]},
  C:{main:["melasma","tone"]},
  E:{main:["dark-circles","eye-area"]},
  A:{main:["pores-blackheads"],sub:["acne-care"]},
  F:{main:["redness","sensitivity"]}
};
var TAG_TOPICS={
  "D":{"dryness":3,"barrier-repair":3,"barrier-science":2},
  "F":{"redness":3,"sensitivity":3},
  "A":{"acne-care":3,"pores-blackheads":2},
  "기초":{"minimal-routine":3,"cleansing":2},
  "조합":{"layering":3}
};
var TAG_SLUG={A:"acne",B:"anti-aging",C:"brightening",D:"moisture-barrier",E:"eye-care",F:"soothing","기초":"skincare-basics","조합":"combining"};
function hubUrl(tg){
  if(typeof NSH_BLOG_URL==="string" && NSH_BLOG_URL){
    return (tg && TAG_SLUG[tg]) ? NSH_BLOG_URL+"/tagged/"+TAG_SLUG[tg] : NSH_BLOG_URL;
  }
  return (typeof TAGURL!=="undefined" && (TAGURL[tg]||TAGURL.all)) || "/blogs/notes";
}
function concernLabel(code){
  try{
    for(var i=0;i<Q.length;i++){ var o=Q[i].o||[];
      for(var j=0;j<o.length;j++){ if(o[j].concern===code && o[j].t) return o[j].t; } }
  }catch(e){}
  return (typeof TAGNAME!=="undefined" && TAGNAME[code]) || __L("지금 고민");
}
/* 좁은 상황 주제 — 그 고민을 고른 게 아니면 '배경 글'로는 감점(계절·갱년기·시술 후 등) */
var NICHE_TOPICS=["seasonal","menopause","hormones","in-your-20s","procedure"];
/* 답변 플래그 → 그 답변과 맞물리는 주제. 같은 고민 안에서 '내 답변에 더 가까운 글'을 위로 올린다.
   플래그는 Q 문항의 o[].flag (step 5단계+ / active 활성3개+ / exfol 각질 주2회+ / more 자극때 덧바름 /
   hotwater 뜨거운물 / layered 역할겹침 / under 거의 안함) */
var FLAG_TOPICS={
  step:{"minimal-routine":2,"layering":1},
  active:{"retinol":2,"vitamin-c":2,"layering":2},
  exfol:{"exfoliation":3,"barrier-repair":1},
  more:{"minimal-routine":2,"barrier-repair":1},
  hotwater:{"cleansing":2},
  layered:{"layering":2,"minimal-routine":1},
  under:{"barrier-repair":1}
};
/* 주제 → 그 주제를 쓰는 상태 태그. 지금 상태와 무관한 축의 글은 배경 글에서 살짝 내린다 */
var TOPIC_OWNER={};
(function(){ for(var tg in TAG_TOPICS){ if(!Object.prototype.hasOwnProperty.call(TAG_TOPICS,tg)) continue;
  var w=TAG_TOPICS[tg];
  for(var t in w){ if(!Object.prototype.hasOwnProperty.call(w,t)) continue;
    (TOPIC_OWNER[t]=TOPIC_OWNER[t]||[]).push(tg); } } })();
function rotSeed(){
  try{ var s=(answers||[]).join(""); var h=0;
    for(var i=0;i<s.length;i++){ h=(h*31+s.charCodeAt(i))>>>0; }
    return h; }catch(e){ return 0; }
}
function pickTie(sorted, keys, seed, off){
  if(!sorted.length) return null;
  var top=sorted[0], grp=sorted.filter(function(x){
    for(var i=0;i<keys.length;i++){ if(x[keys[i]]!==top[keys[i]]) return false; } return true; });
  return grp[(seed+off)%grp.length];
}
/* 추천 3편 = 고른 고민의 글로만 채운다(2026-08-03 파운더 지시).
   ① 히어로글(custom.concern_hero) 고정  ②·③ 내 답변(상태+플래그)에 가까운 순 → 동점은 회전.
   고민 풀이 3편에 못 미치면 상태 기반 배경 글로 보충, 고민 미선택이면 전부 상태 기반. */
function pickArts(st, concern){
  var pool=(typeof NSH_ARTICLES!=="undefined" && NSH_ARTICLES && NSH_ARTICLES.length) ? NSH_ARTICLES : null;
  if(!pool) return null;
  var stTags=(st.arts||[]).slice(0,3);
  var flags=(typeof acc!=="undefined" && acc && acc.flags) ? acc.flags : {};
  var ct=CONCERN_TOPICS[concern]||{}, cset={};
  (ct.main||[]).concat(ct.sub||[]).forEach(function(t){ cset[t]=1; });
  function has(a,t){ return a.p && a.p.indexOf(t)>=0; }
  function isNiche(a){
    for(var i=0;i<NICHE_TOPICS.length;i++){ var t=NICHE_TOPICS[i]; if(has(a,t) && !cset[t]) return true; }
    return false;
  }
  /* 내 답변 점수 = 진단된 상태 축 + 응답 플래그.
     mode "concern" = 고민 풀 안(전부 온토픽) → 좁은 상황 글만 살짝 감점
     mode "bg"      = 배경 글 → 축 이탈·좁은 상황 모두 감점 */
  function ansScore(a, mode){
    var s=0;
    stTags.forEach(function(tg){ var w=TAG_TOPICS[tg]; if(!w) return;
      for(var t in w){ if(Object.prototype.hasOwnProperty.call(w,t) && has(a,t)) s+=w[t]; } });
    for(var f in flags){ if(!flags[f]) continue; var fw=FLAG_TOPICS[f]; if(!fw) continue;
      for(var t2 in fw){ if(Object.prototype.hasOwnProperty.call(fw,t2) && has(a,t2)) s+=fw[t2]; } }
    if(mode==="bg"){
      if(a.p){ for(var k=0;k<a.p.length;k++){ var own=TOPIC_OWNER[a.p[k]];
        if(!own) continue;
        var onAxis=false;
        for(var j=0;j<own.length;j++){ if(stTags.indexOf(own[j])>=0){ onAxis=true; break; } }
        if(!onAxis) s-=1; } }
      if(isNiche(a)) s-=4;
    } else if(isNiche(a)) s-=2;
    return Math.max(0, s);
  }
  function cnScore(a){
    if(!CONCERN_TOPICS[concern]) return 0;
    var s=0;
    (ct.main||[]).forEach(function(t){ if(has(a,t)) s+=2; });
    (ct.sub||[]).forEach(function(t){ if(has(a,t)) s+=1; });
    return s;
  }
  var seed=rotSeed();
  var out=[], taken={};
  function push(x, tg){ out.push({tg:tg, t:x.a.t, u:x.a.u}); taken[x.i]=1; }

  if(concern && CONCERN_TOPICS[concern]){
    /* 고민 풀: 감점 없이(전부 온토픽) 답변 점수만으로 줄 세운다 */
    var cand=pool.map(function(a,i){ return {a:a,i:i,c:cnScore(a),s:ansScore(a,"concern")}; })
      .filter(function(x){ return x.c>0; });
    /* ① 히어로글 */
    for(var hi=0; hi<cand.length; hi++){
      if(cand[hi].a.h===concern){ push(cand[hi], concern); break; }
    }
    /* ②③ 답변 근접순 */
    for(var n=0; out.length<3; n++){
      if(n>3) break;
      var rest=cand.filter(function(x){ return !taken[x.i]; })
        .sort(function(p,q){ return (q.c-p.c)||(q.s-p.s)||(p.i-q.i); });
      var pk=pickTie(rest, ["c","s"], seed, n+1);
      if(!pk) break;
      push(pk, concern);
    }
  }
  /* 고민 풀이 모자라거나 고민 미선택 → 상태 기반 배경 글로 채움 */
  if(out.length<3){
    var bgAll=pool.map(function(a,i){ return {a:a,i:i,s:ansScore(a,"bg")}; });
    for(var m=0; out.length<3; m++){
      if(m>3) break;
      var bg=bgAll.filter(function(x){ return !taken[x.i] && x.s>0; })
        .sort(function(p,q){ return (q.s-p.s)||(p.i-q.i); });
      var b=pickTie(bg, ["s"], seed, m+1);
      if(!b) break;
      push(b, stTags[out.length]||"");
    }
  }
  for(var z=0; z<pool.length && out.length<3; z++){
    if(taken[z]) continue;
    push({a:pool[z], i:z}, "");
  }
  return out.length===3 ? out : null;
}
function renderArts(st, concern){
  let tags, T;
  const picked = pickArts(st, concern);
  if(picked){
    T = picked; tags = picked.map(function(x){ return x.tg; });
  } else {
    tags = st.arts.slice(0,3);
    if(concern && !tags.includes(concern)) tags[2]=concern;
    const used={};
    T=tags.map(tg=>{ const pool=LIB[tg]||LIB["기초"]; used[tg]=(used[tg]||0);
      const it=pool[used[tg]%pool.length]; used[tg]++; return {tg, t:it.t, u:it.u}; });
  }
  const box=document.getElementById("arts"); box.innerHTML="";
  const L=(o)=>'<a href="'+o.u+'" target="_blank" rel="noopener" data-tag="'+o.tg+'">「'+o.t+'」</a>';
  const M=(tg)=>hubUrl(tg);
  let html;
  if(concern && FRAG.s4[concern]){
    const cname=concernLabel(concern);
    const hub='<a href="'+M(concern)+'" target="_blank" rel="noopener" data-tag="'+concern+'-more">'+(__LOC==="en"?"here":"여기")+'</a>';
    html = (__LOC==="en")
      ? ("Start with "+L(T[0])+", then read "+L(T[1])+" and "+L(T[2])+". More on "+cname+" is gathered "+hub+".")
      : (L(T[0])+"에서 시작해 "+L(T[1])+", "+L(T[2])+"까지 차례로 읽어보세요. "+cname+" 이야기가 더 궁금하다면 "+hub+"에 모여 있어요.");
  } else {
    html = __L("지금 상태를 더 알고 싶다면 ")+L(T[0])+", "+L(T[1])+", "+L(T[2])
      +__L(" 세 편을 차례로 읽어보세요. 다른 노트들은 <a href=\"")+M("all")+__L("\" target=\"_blank\" rel=\"noopener\" data-tag=\"all\">여기</a>에 모여 있어요.");
  }
  const p=document.createElement("p"); p.className="note-prose"; p.innerHTML=html;
  box.appendChild(p);
  [...(p.querySelectorAll ? p.querySelectorAll("a") : [])].forEach(a=>{
    a.addEventListener("click",()=>{ logEvent("note_click",{tag:a.dataset.tag,title:a.textContent}); });
  });
}

function gauge(en, labels, on){
  const n=labels.length, pct=((on+0.5)/n*100).toFixed(1);
  return '<div class="axis"><span class="axis-name">'+__L(en)+'</span>'
    +'<span class="meter"><span class="meter-fill" style="width:'+pct+'%"></span><span class="pin" style="left:'+pct+'%"></span></span>'
    +'<span class="axis-val">'+__L(labels[on])+'</span></div>';
}
function fillList(id, arr, caps){
  const ul=document.getElementById(id); ul.innerHTML="";
  arr.forEach(t=>{
    const li=document.createElement("li");
    const wrap=document.createElement("span");
    const lab=document.createElement("span"); lab.className="cut-label"; lab.textContent=__LD(t);
    wrap.appendChild(lab);
    const cap = caps ? caps[t] : null;
    if(cap){ const c=document.createElement("span"); c.className="cut-cap"; c.textContent=cap; wrap.appendChild(c); }
    li.appendChild(wrap);
    ul.appendChild(li);
  });
}

/* ---------- 이메일(결과 지점) · 공유 ---------- */
function __hasJoined(){ try{ return localStorage.getItem("nshJoined")==="1"; }catch(e){ return false; } }
function joinWaitlist(ev){
  var __hp=document.getElementById("nshHp"); if(__hp && __hp.value){ if(ev&&ev.preventDefault) ev.preventDefault(); return false; }
  const e=document.getElementById("email").value.trim();
  if(!e||!/.+@.+\..+/.test(e)){ if(ev&&ev.preventDefault) ev.preventDefault(); document.getElementById("emailErr").style.display='block'; document.getElementById("email").focus(); return false; }
  document.getElementById("emailErr").style.display='none';
  const w=window.__wl||{};
  logEvent("waitlist_join",{email:e, at:"result", state:w.state, load:w.load});
  const slug=w.slug||"";
  const tg=document.getElementById("wlTags"); if(tg) tg.value="quiz-waitlist"+(slug?",state-"+slug:"")+(w.load?",load-"+w.load:"");
  const rt=document.getElementById("wlReturn");
  if(rt){ let base="/pages/ritual-reading"; try{ if(location && location.pathname) base=location.pathname; }catch(e2){}
    rt.value=base+"?state="+slug+"&joined=1"; }
  try{ localStorage.setItem("nshJoined","1"); }catch(e){}
  return true; /* 검증 통과 → 네이티브 POST(고객 원장) 진행, 시트 비컨은 위에서 발화 */
}
function markJoined(){
  var box=document.getElementById("wlBox"); if(box) box.style.display="none";
  var sw=document.getElementById("shareWrap"); if(sw&&sw.classList) sw.classList.remove("hidden");
  var eb=document.getElementById("endBand"); if(eb&&eb.classList) eb.classList.add("joined-band");
}
/* ---------- 공유 카드 — 계기판+심장 문장 이미지 (1:1·9:16, 제품 미포함) ---------- */
function cardWrap(g, text, maxW){
  if(g.measureText(text).width<=maxW) return [text];
  const words=text.split(" ");
  let best=null;                       /* 두 줄 균형 분할(어절 경계) */
  for(let i=1;i<words.length;i++){
    const a=words.slice(0,i).join(" "), b=words.slice(i).join(" ");
    const wa=g.measureText(a).width, wb=g.measureText(b).width;
    if(wa<=maxW && wb<=maxW){ const dd=Math.abs(wa-wb); if(!best||dd<best.dd) best={a,b,dd}; }
  }
  if(best) return [best.a,best.b];
  const out=[]; let line="";           /* 폴백: 어절 그리디 */
  words.forEach(wd=>{ const t=line?line+" "+wd:wd;
    if(g.measureText(t).width>maxW && line){ out.push(line); line=wd; } else line=t; });
  if(line) out.push(line);
  return out;
}
function drawCard(w,h){
  const d=window.__cardData||{stateName:""};
  const c=document.createElement("canvas"); c.width=w; c.height=h;
  const g=c.getContext("2d"); const S=w/1080; const tall=h>w;
  /* 배경 = 상태 정물 커버핏, 무틴트 (07-16 포스터 문법). 미확보 시 웜 다크 솔리드 */
  const im=window.__cardImg;
  if(im && im.complete && im.naturalWidth){
    const sc=Math.max(w/im.naturalWidth, h/im.naturalHeight);
    const dw=im.naturalWidth*sc, dh=im.naturalHeight*sc;
    g.drawImage(im,(w-dw)/2,(h-dh)/2,dw,dh);
  } else { g.fillStyle="#2E2A23"; g.fillRect(0,0,w,h); }
  /* 하단 국소 그라디언트: 텍스트 존만, 이미지 본체는 순정 */
  const gy=h*(tall?0.60:0.54);
  const grd=g.createLinearGradient(0,gy,0,h);
  grd.addColorStop(0,"rgba(33,26,19,0)"); grd.addColorStop(.45,"rgba(33,26,19,.24)"); grd.addColorStop(1,"rgba(33,26,19,.56)");
  g.fillStyle=grd; g.fillRect(0,gy,w,h-gy);
  const cx=w/2, W="#FCFCFB";
  g.textAlign="center";
  /* 하단 중앙 스택: 날짜 라벨 / 상태명(균형 줄바꿈+자동 축소) / EN 서명 */
  const __d=new Date(), __z=n=>String(n).padStart(2,"0");
  const dateLine=__d.getFullYear()+". "+__z(__d.getMonth()+1)+". "+__z(__d.getDate())+(__LOC==="en"?". My skin state today":". 지금 나의 피부 상태는");
  let ns=76;
  const setNF=()=>{ g.font="700 "+Math.round(ns*S)+"px Pretendard, sans-serif"; };
  setNF();
  let lines=[d.stateName||""];
  if(g.measureText(lines[0]).width > w*0.86){
    const ws=(d.stateName||"").split(" "); let best=null;
    for(let i=1;i<ws.length;i++){
      const a=ws.slice(0,i).join(" "), b=ws.slice(i).join(" ");
      const mw=Math.max(g.measureText(a).width, g.measureText(b).width);
      if(!best || mw<best.mw) best={mw:mw,a:a,b:b};
    }
    if(best){
      lines=[best.a,best.b];
      while(ns>40 && Math.max(g.measureText(lines[0]).width,g.measureText(lines[1]).width) > w*0.86){ ns-=3; setNF(); }
    }
  }
  const lh=Math.round(ns*1.26*S);
  const padB=Math.round((tall?116:86)*S);
  const enY=h-padB;
  const nameBottom=enY-Math.round((tall?66:58)*S);
  const nameTop=nameBottom-(lines.length-1)*lh;
  const dateY=nameTop-Math.round(ns*S*0.98)-Math.round((tall?30:26)*S);
  g.fillStyle="rgba(252,252,251,.93)";
  g.font=Math.round(26*S)+"px Pretendard, sans-serif";
  g.fillText(dateLine, cx, dateY);
  g.fillStyle=W; setNF();
  lines.forEach((t,i)=>{ g.fillText(t, cx, nameTop+i*lh); });
  g.fillStyle="rgba(252,252,251,.94)";
  g.font="400 "+Math.round(33*S)+"px 'Instrument Serif', Georgia, serif";
  g.fillText("Innate state, optimum beauty. Nooy Suhsuh", cx, enY);
  if(typeof window==="undefined" || window.__cardUrlLine!==false){ /* 카드 URL 라인: EN 서명과 동일 서체, 사이즈만 작게 (나은 07-17) */
    g.fillStyle="rgba(252,252,251,.8)";
    g.font="400 "+Math.round(26*S)+"px 'Instrument Serif', Georgia, serif";
    g.fillText(__LOC==="en"?"nooysuhsuh.com/ritual-reading":"nooysuhsuh.com/ko/ritual-reading", cx, h-Math.round((tall?56:38)*S));
  }
  return c;
}
function shareUrl(){
  try{ const u=new URL(location.href); u.searchParams.set("ref","share"); if(window.__ans) u.searchParams.set("a", window.__ans); return u.toString(); }
  catch(e){ return location.href; }
}
function shareText(){
  const d=window.__cardData||{};
  if(__LOC==="en") return (d.stateName? "My skin right now: '"+d.stateName+"'. ":"")+"How about yours?";
  return (d.stateName? "제 피부는 지금 '"+d.stateName+"' 상태래요. ":"")+"당신의 피부는요?";
}
async function shareResult(){
  logEvent("share_click",{card:true});
  const text=shareText(), url=shareUrl();
  try{
    if(document.fonts && document.fonts.ready) await document.fonts.ready;
    const blob=await new Promise(res=>drawCard(1080,1080).toBlob(res,"image/png"));
    const file=new File([blob],"nooysuhsuh-skin-state.png",{type:"image/png"});
    if(navigator.canShare && navigator.canShare({files:[file]})){
      await navigator.share({files:[file], text:text+" "+url}); return;
    }
    if(navigator.share){ await navigator.share({title:(__LOC==="en"?"Skin Ritual Reading":"피부 리추얼 리딩"), text:text, url:url}); return; }
    const a=document.createElement("a"); a.href=URL.createObjectURL(blob); a.download="nooysuhsuh-skin-state.png"; a.click();
    if(navigator.clipboard) navigator.clipboard.writeText(text+" "+url);
  }catch(e){ /* 공유 시트 취소 등 */ }
}
async function saveCard(w,h){
  logEvent("share_card_save",{ratio:w+"x"+h});
  if(document.fonts && document.fonts.ready) await document.fonts.ready;
  const blob=await new Promise(res=>drawCard(w,h).toBlob(res,"image/png"));
  const a=document.createElement("a"); a.href=URL.createObjectURL(blob);
  a.download="nooysuhsuh-skin-state-"+(h>w?"9x16":"1x1")+".png"; a.click();
}
function restart(){ stripShareParams(); setMedia("r0"); show("intro"); window.scrollTo(0,0); }

const NSH_TRACK_ENDPOINT="https://script.google.com/macros/s/AKfycbxr1dl9VHWm1hKlUFozrDeXNlg-Y-Z_l6FizSU9IE2Llf_9mdeSnv5sHgyP9aj5UfeEfg/exec"; /* ← 구글시트 Apps Script 웹앱 URL 붙여넣기. 비어 있으면 수집 꺼짐(dataLayer/GTM은 그대로 동작) */
function logEvent(name, payload){
  const rec={event:name, ts:new Date().toISOString(), ...payload};
  window.dataLayer=window.dataLayer||[]; window.dataLayer.push(rec);
  if(NSH_TRACK_ENDPOINT && typeof navigator!=="undefined" && navigator.sendBeacon){
    try{ navigator.sendBeacon(NSH_TRACK_ENDPOINT, new Blob([JSON.stringify(rec)],{type:"text/plain;charset=UTF-8"})); }catch(e){}
  }
  console.log("[quiz]", rec);
}
try{ const __sp0=new URL(location.href).searchParams; if(__sp0.get("ref")==="share") logEvent("quiz_visit_from_share",{state:__sp0.get("state")||""}); }catch(e){}


/* ---------- 웨이브2 (07-17): 결과 URL 랜딩 · 로딩 베일 · 복귀 처리 ---------- */
function revealResult(){
  const veil=document.getElementById("veil");
  if(typeof Image==="undefined" || !veil || !veil.classList){ show("result"); window.scrollTo(0,0); return; }
  const n=answers.filter(a=>a!==undefined&&a!==null).length || Q.length;
  const vt=document.getElementById("veilText");
  if(vt) vt.textContent=n+__L("개의 답을, 하나의 상태로 정리하고 있어요.");
  const vi=document.getElementById("veilImg"); if(vi && !vi.src) vi.src=imgUrl("state-r9-bw"); /* start()에서 선로드 완료 */
  veil.classList.remove("hidden"); void veil.offsetWidth; veil.classList.add("on");
  const t0=Date.now(); let done=false;
  const settle=()=>{ if(done) return; done=true;
    show("result"); window.scrollTo(0,0);
    veil.classList.remove("on"); setTimeout(()=>{ veil.classList.add("hidden"); },360); };
  const img=window.__cardImg;
  const tick=()=>{ if(done) return;
    const el=Date.now()-t0, ready=!img || img.complete;
    if(el>=3000 || (el>=1500 && ready)) settle(); else setTimeout(tick,120); };
  setTimeout(tick,120);
}
function stripShareParams(){
  try{ if(typeof history!=="undefined" && history.replaceState){ const u=new URL(location.href); u.searchParams.delete("state"); u.searchParams.delete("joined"); u.searchParams.delete("ref"); history.replaceState(null,"",u.toString()); } }catch(e){}
}
function startFromShare(){
  logEvent("share_landing_start",{state:(window.__sharedKey&&STATE_SLUGS[window.__sharedKey])||""});
  stripShareParams();
  const cf=document.getElementById("ctaFloat"); if(cf&&cf.classList) cf.classList.add("hidden");
  if(document.body && document.body.classList) document.body.classList.remove("shared-view");
  ["cutSec","slotSec","noteSec","endBand"].forEach(id=>{ const el=document.getElementById(id); if(el&&el.classList) el.classList.remove("hidden"); });
  const cta=document.getElementById("sharedCta"); if(cta&&cta.classList) cta.classList.add("hidden");
  const rl=document.getElementById("rLabel"); if(rl) rl.textContent=__L("오늘 내 피부 상태는");
  start();
}
function renderShared(key, joined){
  const P=key.slice(0,2), care=key.charAt(2)==="T";
  const st=STATES[P][care], R=READINGS[P][care];
  window.__sharedKey=key; window.__cardData={stateName:st.name};
  const rl=document.getElementById("rLabel"); if(rl) rl.textContent=__L("공유받은 피부 상태예요:");
  document.getElementById("typeName").textContent=st.name;
  document.getElementById("resultTitle").textContent=R.heart;
  if(STATE_IMGS[key]) document.getElementById("stateImg").src=imgUrl(STATE_IMGS[key]);
  setMedia(STATE_IMGS[key]||"r9");
  document.getElementById("gauges").innerHTML =
    gauge("유분",["낮음","보통","높음"],st.oil)
    + gauge("수분",["낮음","충분"],st.water)
    + gauge("장벽",["안정","돌봄 필요"],care?1:0);
  const rd=document.getElementById("reading"); rd.innerHTML="";
  R.p.forEach(t=>{ const p=document.createElement("p"); p.innerHTML=mdBold(t); rd.appendChild(p); });
  /* 상태 전문 공개(07-17): 상태에서 나오는 건 전부 보여주고, 답변 유래(덜어낼)만 잠금 티저 */
  document.getElementById("dontList").innerHTML="";
  const ce=document.getElementById("cutEmpty"); if(ce){ ce.textContent=CUT_TEASER; ce.style.display="block"; }
  const cl2=document.getElementById("cutLead"); if(cl2) cl2.style.display="none";
  const sb2=document.getElementById("sigSec"); if(sb2) sb2.style.display="none";
  renderSlots({P:P, care:care, load:"공유랜딩"}, st);
  const br=document.getElementById("concernBridge"); if(br&&br.style) br.style.display="none";
  renderArts(st, "");
  const eb=document.getElementById("endBand"), cta=document.getElementById("sharedCta"), sw=document.getElementById("shareWrap");
  if(joined){
    if(eb&&eb.classList) eb.classList.remove("hidden");
    if(sw&&sw.classList) sw.classList.add("hidden");
    if(cta&&cta.classList) cta.classList.add("hidden");
    markJoined();
  } else {
    if(eb&&eb.classList) eb.classList.add("hidden");
    if(cta&&cta.classList) cta.classList.remove("hidden");
    showCtaFloat();
  }
  if(document.body && document.body.classList) document.body.classList.add("shared-view");
  show("result"); window.scrollTo(0,0);
}
function decorateShared(){
  const rl=document.getElementById("rLabel"); if(rl) rl.textContent=__L("공유받은 피부 상태예요:");
  const eb=document.getElementById("endBand"); if(eb&&eb.classList) eb.classList.add("hidden");
  const cta=document.getElementById("sharedCta"); if(cta&&cta.classList) cta.classList.remove("hidden");
  showCtaFloat();
  if(document.body && document.body.classList) document.body.classList.add("shared-view");
}
function showCtaFloat(){
  const cf=document.getElementById("ctaFloat"); if(!cf||!cf.classList) return;
  cf.classList.remove("hidden");
  const cta=document.getElementById("sharedCta");
  if(typeof IntersectionObserver!=="undefined" && cta){
    try{ if(!window.__ctaIO){ window.__ctaIO=new IntersectionObserver(es=>{ es.forEach(en=>{ cf.classList.toggle("off", en.isIntersecting); }); },{threshold:.18}); window.__ctaIO.observe(cta); } }catch(e){}
  }
}
/* 라우팅 부트: ?state=슬러그 → 세션 복원(내 결과) 또는 공유 랜딩 기본형. 직접 진입은 로딩 베일 없음 */
(function(){
  try{ if("scrollRestoration" in history) history.scrollRestoration="manual"; }catch(e){}
  let sp=null; try{ sp=new URL(location.href).searchParams; }catch(e){}
  if(!sp || !sp.get) return;
  if(sp.get("start")==="1" && !sp.get("state")){ try{ start(); }catch(e){} return; }
  const slug=sp.get("state"); if(!slug) return;
  const key=SLUG_KEYS[slug]; if(!key) return;
  const joined=sp.get("joined")==="1";
  const aRaw=sp.get("a")||"";
  let saved=null;
  try{ if(typeof localStorage!=="undefined") saved=JSON.parse(localStorage.getItem("nshQuizR")||"null"); }catch(e){ saved=null; }
  const ownOk = saved && saved.k===key && Array.isArray(saved.a) && saved.a.length===Q.length && saved.a.every(ai=>typeof ai==="number");
  const replay = arr => { answers=arr.slice(); idx=Q.length-1; resetAcc();
    for(let qi=0;qi<Q.length;qi++){ const o=Q[qi].o[answers[qi]]; if(!o) continue;
      Object.entries(o.s||{}).forEach(([k2,v])=>{ acc[k2]+=v; }); if(o.flag) acc.flags[o.flag]=true; if(o.concern!==undefined) acc.concern=o.concern; } };
  const aOk = aRaw.length===Q.length && aRaw.split("").every((c,qi)=>{ const n=Number(c); return Number.isInteger(n) && n>=0 && Q[qi] && n<Q[qi].o.length; });
  if(aOk && !(ownOk && saved.a.join("")===aRaw)){
    replay(aRaw.split("").map(Number));   /* 공유자 결과 전문 뷰 */
    finish({restore:true, shared:true});
  } else if(ownOk){
    replay(saved.a);
    finish({restore:true, joined:joined});
  } else {
    renderShared(key, joined);            /* 상태 전문 랜딩(답변 유래만 티저) */
  }
})();
if(typeof window!=="undefined" && window.addEventListener){ window.addEventListener("popstate", function(){ try{ location.reload(); }catch(e){} }); }

